import "./About.module.css";
import Navigation from "@/reusable_sections/Header";
import Narrative from "./sections/Narrative";
import Principles from "./sections/Principles";
import Connect from "./sections/Connect";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Navigation />
      <Narrative />
      <Principles />
      <Connect />
      <Footer />
    </div>;
}